document.addEventListener('DOMContentLoaded', () => {

  let background = ''
  let text_color = ''

  document.querySelectorAll('.info-bar__timer-container').forEach((container) => {

    const infoBarEndDate = container.querySelector('#info_bar_end_date');
    const infoBarTimeLeft = container.querySelector('.info-bar__time-left');
  
    if (!infoBarEndDate || !infoBarTimeLeft) return; // Если нет нужных элементов - пропускаем
  
    function calculateDatesDifference() {
      const now = new Date();
      const endDate = new Date(infoBarEndDate.textContent.trim());
      const diff = Date.parse(endDate) - Date.parse(now);
  
      const days = Math.floor(diff / (1000 * 3600 * 24));
      const hours = Math.floor((diff / (1000 * 3600)) % 24);
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
  
      // if (diff > 0) {
      //   infoBarTimeLeft.innerHTML = ` | Ends in: <span class="time-style">${days}d, ${hours}h, ${minutes}m, ${seconds}s</span>`;
      // } else {
      //   infoBarTimeLeft.innerHTML = 'Time is over';
      //   clearInterval(timeLeftInterval); // Останавливаем только текущий таймер
      // }
  
      infoBarTimeLeft.innerHTML =
      diff > 0
        ? ` Ends in: <span class="time-style">${days}d, ${hours}h, ${minutes}m, ${seconds}s</span>`
        : 'Time is over';
    return diff;
    }
  
    // Запускаем таймер
    calculateDatesDifference();
    const timeLeftInterval = setInterval(calculateDatesDifference, 1000);
  });
})

